import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMerged: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconMerged"><Path d="M6 3C7.30585 3 8.41406 3.83532 8.82617 5H19V15.1738C20.1647 15.5859 21 16.6941 21 18C21 19.6569 19.6569 21 18 21C16.3431 21 15 19.6569 15 18C15 16.6941 15.8353 15.5859 17 15.1738V7H8.82617C8.52487 7.85152 7.85148 8.5238 7 8.8252V15.1738C8.16468 15.5859 9 16.6941 9 18C9 19.6569 7.65685 21 6 21C4.34315 21 3 19.6569 3 18C3 16.6941 3.83532 15.5859 5 15.1738V8.8252C3.83548 8.41299 3 7.30574 3 6C3 4.34315 4.34315 3 6 3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMerged;
